import { AxiosResponse } from 'axios';
import { NotificationSide } from 'civil-status/model/notification-side';
import { NotificationsListSide } from 'civil-status/view-models/notifications-list-side';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';
import { getNameTypeEvent } from './get-name-type-event';

export const transformNotificationsListSide = (
  response: AxiosResponse<HttpResponse<NotificationSide>>
): Array<NotificationsListSide> => {
  const dataRes = response.data.payload.listDatiComunicazione || [];
  const datiPaginazione = response.data.payload.datiPaginazione || {};

  return dataRes.map((item) => ({
    currentItem: item as NotificationSide,
    totalCount: datiPaginazione.numRecordTotali || 0,
    ambito: item.ambito || '',
    description: item.descrizione || '',
    formationDate: item.formazione
      ? DateTime.fromISO(item.formazione).toFormat('dd/MM/yyyy HH:mm')
      : '',
    municipalityDestination: item.comuneDestinatario || '',
    operator: item.cognomeNomeOperatore || '',
    register: getNameTypeEvent(item.registroDestinazione) || '',
    registerSource: getNameTypeEvent(item.registroSorgente) || '',
    sourceEvent: item.eventoSorgente || '',
  }));
};
